module.exports = __webpack_public_path__ + "img/libImg.0ec2e6f8.jpg";